var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyPrimaryStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99956 9.51332L8.76622 11.1867C9.27289 11.4933 9.89289 11.04 9.75956 10.4667L9.02623 7.31999L11.4729 5.19999C11.9196 4.81332 11.6796 4.07999 11.0929 4.03332L7.87289 3.75999L6.61289 0.786653C6.38623 0.246653 5.61289 0.246653 5.38623 0.786653L4.12623 3.75332L0.906227 4.02665C0.31956 4.07332 0.0795601 4.80665 0.526227 5.19332L2.97289 7.31332L2.23956 10.46C2.10623 11.0333 2.72623 11.4867 3.23289 11.18L5.99956 9.51332Z",
    fill: "#ECF0FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPrimaryStar);
export default __webpack_public_path__ + "static/media/emptyPrimaryStar.bf999a52.svg";
export { ForwardRef as ReactComponent };